exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#mlButtonAnnuler[data-v-1eec7647]{margin-right:20px}.marginResearch[data-v-1eec7647]{margin-right:10px}.divResearch[data-v-1eec7647]{margin-right:-5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1eec7647","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/Submission.vue
// module id = 707
// module chunks = 0